var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-reactroot": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M340.133 416.263C452.319 416.263 543.263 325.319 543.263 213.134C543.263 100.949 452.319 10.0044 340.133 10.0044C227.948 10.0044 137.004 100.949 137.004 213.134C137.004 325.319 227.948 416.263 340.133 416.263Z",
    fill: "#8FE4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M657.294 553.949L487.323 353.117C558.009 278.962 562.888 161.896 495.17 81.8929C454.992 34.4252 397.708 10.0015 340.042 10.0015C316.852 10.0015 293.603 13.9395 271.383 21.9339C249.164 29.8996 227.972 41.9496 208.897 58.0855C123.28 130.565 112.611 258.741 185.09 344.358C225.268 391.826 282.552 416.28 340.248 416.28C379.721 416.28 419.399 404.758 453.875 381.392L623.876 582.254C631.664 591.482 645.508 592.629 654.737 584.81C659.851 580.49 662.496 574.318 662.496 568.087C662.496 563.09 660.791 558.065 657.294 553.949ZM452.376 345.74C421.045 372.28 381.22 386.888 340.248 386.888C288.96 386.888 240.611 364.462 207.516 325.372C177.536 289.955 163.135 244.986 166.985 198.724C170.835 152.491 192.467 110.491 227.884 80.5109C259.216 54.0004 299.041 39.393 340.042 39.393C391.301 39.393 439.679 61.8183 472.745 100.88C534.643 174.005 525.502 283.871 452.376 345.74Z",
    fill: "#265ed5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M377.411 197.27C409.247 197.27 435.055 171.462 435.055 139.625C435.055 107.789 409.247 81.9805 377.411 81.9805C345.574 81.9805 319.766 107.789 319.766 139.625C319.766 171.462 345.574 197.27 377.411 197.27Z",
    fill: "#B3CAF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLens);
export default __webpack_public_path__ + "static/media/lens.5e4369bb0a515a27c8d136d9612abe7b.svg";
export { ForwardRef as ReactComponent };